import {
  Box,
  Button,
  TextField,
  useMediaQuery,
  MenuItem,
} from "@mui/material";
import * as React from "react";
import { useRenumerationTypesList } from "api/hooks/humanResource";

const RenumerationDetailForm = (props) => {
  const {
    index,
    data,
    handleRemoveProductDetailRow,
    handleItemAmountChange,
    name,
    errors,
    touched,
    handleBlur,
    handleChange,
    businessBranchId,
  } = props;
  const isNonMobile = useMediaQuery("(min-width:600px)");

  const { renumerationTypeList } = useRenumerationTypesList(1, businessBranchId);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
      }}
    >
      <Box>
        <p>#{index + 1}</p>
      </Box>
      <Box
        display="grid"
        gap="30px"
        p="0.5rem"
        gridTemplateColumns="repeat(5, minmax(0, 1fr))"
        sx={{
          "& > div": { gridColumn: isNonMobile ? undefined : "span 10" },
        }}
      >
        <>
          <TextField
            label="Renumeration"
            size="small"
            onBlur={handleBlur}
            onChange={handleChange}
            select
            value={data.related_renumeration_type}
            name={`${name}.related_renumeration_type`}
            error={
              Boolean(
                touched?.renumeration_detail &&
                  touched?.renumeration_detail[index]
                    ?.related_renumeration_type
              ) &&
              Boolean(
                errors?.renumeration_detail &&
                  errors?.renumeration_detail[index]
                    ?.related_renumeration_type
              )
            }
            helperText={
              touched?.renumeration_detail &&
              touched?.renumeration_detail[index]
                ?.related_renumeration_type &&
              errors?.renumeration_detail &&
              errors?.renumeration_detail[index]?.related_renumeration_type
            }
            sx={{ gridColumn: "span 2" }}
          >
            {renumerationTypeList.map((oneUnit, index) => {
              return (
                <MenuItem
                  key={index}
                  value={oneUnit.id}
                  selected={oneUnit.id === data.related_renumeration_type  ? true  : false}
                >
                  {oneUnit.renumeration_name}
                </MenuItem>
              );
            })}
          </TextField>

          <TextField
            label="Amount"
            size="small"
            type="number"
            onBlur={handleBlur}
            onChange={(e) => {
              handleChange(e);
              handleItemAmountChange(e, index);
            }}
            value={data.amount}
            inputProps={{
              min: 0,
            }}
            name={`${name}.amount`}
            error={
              Boolean(
                touched?.renumeration_detail &&
                  touched?.renumeration_detail[index]?.amount
              ) &&
              Boolean(
                errors?.renumeration_detail &&
                  errors?.renumeration_detail[index]?.amount
              )
            }
            helperText={
              touched?.renumeration_detail &&
              touched?.renumeration_detail[index]?.amount &&
              errors?.renumeration_detail &&
              errors?.renumeration_detail[index]?.amount
            }
            sx={{ gridColumn: "span 2" }}
          />

          {index > 0 ? (
            <Button
              value={index}
              onClick={() => {
                handleRemoveProductDetailRow(index);
              }}
              size="small"
              variant="contained"
              sx={{
                width: "20%",
              }}
            >
              Remove
            </Button>
          ) : null}
        </>
      </Box>
    </Box>
  );
};

export default RenumerationDetailForm;
